<template>
  <div data-cy="page-recapitulatif-vigeo">
    <SlHeader
      :current-step="4"
      :links="headerLinks"
    />

    <sl-separator class="mb-4" />

    <recapitulatif-intro :user="user" />

    <recapitulatif-personal-informations :user="user" />

    <recapitulatif-needs-vigeo :user="user" />

    <recapitulatif-complementary-informations :user="user" />

    <recapitulatif-final />

    <sl-button
      v-if="user.partenaireCanSign && !user.fromUrlAppo"
      @click="submit()"
    >
      Confirmer ma souscription en ligne
    </sl-button>

    <a
      v-if="!(user.partenaireCanSign && !user.fromUrlAppo)"
      :href="downloadDocumentsURL"
      target="_blank"
    ><sl-button>Télécharger les documents récapitulatifs</sl-button></a>
  </div>
</template>

<script>

import {useVuelidate} from '@vuelidate/core'
import SlButton from "src/modules/shared/components/SlButton";
import SlSeparator from "src/modules/shared/components/SlSeparator";
import {computed, onMounted, ref} from "vue";
import RecapitulatifVigeoService from "src/modules/recapitulatif/services/recapitulatif-vigeo.service";
import RecapitulatifFinal from "src/modules/recapitulatif/components/RecapitulatifFinal";
import RecapitulatifPersonalInformations from "src/modules/recapitulatif/components/RecapitulatifPersonalInformations";
import RecapitulatifNeedsVigeo from "src/modules/recapitulatif/components/RecapitulatifNeedsVigeo";
import RecapitulatifComplementaryInformations from "src/modules/recapitulatif/components/RecapitulatifComplementaryInformations";
import RecapitulatifIntro from "src/modules/recapitulatif/components/RecapitulatifIntro";
import SlHeader from "src/modules/shared/components/SlHeader";

export default {
  name: "RecapitulatifVigeo",
  components: {
    RecapitulatifComplementaryInformations,
    RecapitulatifIntro,
    RecapitulatifNeedsVigeo,
    RecapitulatifPersonalInformations,
    RecapitulatifFinal,
    SlButton,
    SlHeader,
    SlSeparator
  },
  setup() {
    const initialState = window.__INITIAL_STATE__ || {}
    let user = ref({})

    const headerLinks = computed(() => [
      user.value ? user.value.devoirDeConseilUrl : null,
      user.value ? user.value.quoteUrl : null,
      user.value ? user.value.souscriptionUrl : null,
    ])

    onMounted(async () => {
      await RecapitulatifVigeoService.getUserInformations().then(res => {
        console.debug('RecapitulatifSante', 'getUser', res.data)
        user.value = res.data
      })
    })

    return {
      v$: useVuelidate(),
      user,
      initialState,
      headerLinks
    }
  },
  computed: {
    downloadDocumentsURL: () => {
      return RecapitulatifVigeoService.getDownloadDocumentsURL()
    }
  },
  methods: {
    async submit() {
      await RecapitulatifVigeoService.submitForm().then(res => {
        console.log(res.data)
      })
    }
  }
}
</script>

<style scoped>

</style>
